export default __webpack_public_path__ + "static/media/ceo_replace.67de0e17.PNG";